import { useEffect, useState } from 'react';
import { KEY_SCHEMES, type KeyScheme } from '@schnitt/shared';

/**
 * Die gewählte Tastenbelegung.
 *
 * Sie gehört zum Gerät, nicht zum Konto: am Schnittplatz sitzt, wer dort
 * sitzt, und wer von der Redaktion an den Schnittrechner wechselt, erwartet
 * dort die Belegung des Schnittrechners. Deshalb im Browser gespeichert und
 * nicht auf dem Server.
 */
const SCHLUESSEL = 'schnitt.tastenbelegung';

function gelesen(): KeyScheme {
  try {
    const wert = localStorage.getItem(SCHLUESSEL);
    if (KEY_SCHEMES.some((s) => s.id === wert)) return wert as KeyScheme;
  } catch {
    /* Ein Browser ohne Speicher ist kein Grund, nicht zu arbeiten. */
  }
  return 'schnitt';
}

/** Damit ein Wechsel sofort überall gilt, nicht erst nach dem Neuladen. */
const horcher = new Set<(scheme: KeyScheme) => void>();

export function setKeyScheme(scheme: KeyScheme): void {
  try {
    localStorage.setItem(SCHLUESSEL, scheme);
  } catch {
    /* siehe oben */
  }
  for (const h of horcher) h(scheme);
}

export function useKeyScheme(): KeyScheme {
  const [scheme, setScheme] = useState<KeyScheme>(gelesen);
  useEffect(() => {
    horcher.add(setScheme);
    return () => {
      horcher.delete(setScheme);
    };
  }, []);
  return scheme;
}
